const template = require('./advancedDropdown.component.html');

angular.module('bb.users').component('advancedDropdown', {
  bindings: {
    selectedItem: '<',
    list: '<',
    enableSearch: '<',
    displayProp: '@',
    onSelected: '&',
    onDeselected: '&',
  },
  controller: AdvancedDropdownController,
  template,
});

function AdvancedDropdownController() {
  this.$onInit = () => {
    this.extraSettings = {
      enableSearch: this.enableSearch,
      clearSearchOnClose: true,
      selectionLimit: 1,
      displayProp: this.displayProp,
      searchField: this.displayProp,
      closeOnSelect: true,
      closeOnDeselect: true,
      showCheckAll: false,
      showUncheckAll: false,
    };

    this.events = {
      onItemSelect: this.onSelected,
      onItemDeselect: this.onDeselected,
    };
  };

  this.deselect = () => {
    this.onDeselected();
  };
}
